/* Amazing Graze Flowers — theme interactions
   Reveal, header, predictive search, cart drawer (date/time gated checkout),
   PDP (variants, afterpay, add-ons, card message), collection filters,
   cart page, mobile accordions, premium mobile menu */
(function () {
  'use strict';

  /* ── Helpers ── */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  var moneyFormat = (window.PB && window.PB.moneyFormat) || '${{amount}}';
  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    if (/\{\{\s*amount_no_decimals\s*\}\}/.test(moneyFormat)) value = Math.round(cents / 100).toString();
    return moneyFormat.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, value);
  }
  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  var toastEl;
  function toast(msg, ok) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'pb-toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.toggle('ok', !!ok);
    toastEl.classList.add('show');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('show'); }, 2400);
  }

  /* ── Reveal on scroll ── */
  function initReveal() {
    var els = $$('.r');
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('v'); }); return; }
    var ro = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('v'); ro.unobserve(e.target); }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -30px 0px' });
    els.forEach(function (el) { ro.observe(el); });
  }

  /* ── Header ── */
  function initHeader() {
    var hdr = $('.hdr');
    if (hdr) {
      window.addEventListener('scroll', function () {
        hdr.classList.toggle('scrolled', window.scrollY > 8);
      }, { passive: true });
    }

    var drawer = $('#pbMobDrawer');
    var burger = $('#pbHamburger');
    if (burger && drawer) {
      burger.addEventListener('click', function () { drawer.classList.add('open'); document.body.style.overflow = 'hidden'; });
      $$('.mob-drawer-bg, .mm-close', drawer).forEach(function (el) {
        el.addEventListener('click', function () { drawer.classList.remove('open'); document.body.style.overflow = ''; });
      });
      /* premium menu submenu toggles */
      $$('.mm-link[data-mm-toggle]', drawer).forEach(function (b) {
        b.addEventListener('click', function () { b.closest('.mm-item').classList.toggle('open'); });
      });
    }
  }

  /* ── Same-day countdown ── */
  function initCountdown() {
    var els = $$('[data-pb-countdown]');
    if (!els.length) return;
    function tick() {
      els.forEach(function (el) {
        var cutoff = parseInt(el.getAttribute('data-pb-countdown'), 10) || 15;
        var now = new Date(), c = new Date();
        c.setHours(cutoff, 0, 0, 0);
        if (now >= c) { el.textContent = 'Tomorrow'; return; }
        var d = c - now, h = Math.floor(d / 3600000), m = Math.floor((d % 3600000) / 60000);
        el.textContent = h + 'h ' + m + 'm' + (el.hasAttribute('data-pb-left') ? ' left' : '');
      });
    }
    tick(); setInterval(tick, 60000);
  }

  /* ── Cart count bubble ── */
  function setCartCount(n) {
    $$('[data-pb-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.setAttribute('data-count', n);
    });
  }

  /* ══════════════════════════════════════════════
     PREMIUM CART DRAWER — date + time gate checkout
  ══════════════════════════════════════════════ */
  var Drawer = {
    el: null, cart: null,
    cfg: { freeShip: 12000, cutoff: 15, closedDay: 0, tz: 'Australia/Sydney' },
    init: function () {
      this.el = $('#pbCartDrawer');
      if (!this.el) return;
      var self = this;
      this.cfg.freeShip = parseInt(this.el.getAttribute('data-free-ship'), 10) || 12000;
      this.cfg.cutoff = parseInt(this.el.getAttribute('data-cutoff'), 10) || 15;
      this.cfg.tz = this.el.getAttribute('data-tz') || 'Australia/Sydney';

      $$('.cdrw-bg, .cdrw-close', this.el).forEach(function (x) {
        x.addEventListener('click', function () { self.close(); });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') self.close();
      });

      /* header cart icons open the drawer */
      $$('[data-pb-drawer-toggle]').forEach(function (a) {
        a.addEventListener('click', function (e) { e.preventDefault(); self.open(); });
      });

      /* date input — min/max anchored to the store's "today", not the visitor's */
      var date = $('#cdrwDate');
      if (date) {
        var todayStr = this.storeNow().date;
        date.min = todayStr;
        var max = new Date(todayStr + 'T12:00:00');
        max.setDate(max.getDate() + 45);
        date.max = max.toISOString().slice(0, 10);
        date.addEventListener('change', function () { self.onDate(); });
      }
      $$('.cdrw-slot', this.el).forEach(function (s) {
        s.addEventListener('click', function () {
          $$('.cdrw-slot', self.el).forEach(function (x) { x.classList.remove('on'); });
          s.classList.add('on');
          self.saveSchedule();
        });
      });

      var co = $('#cdrwCheckout');
      if (co) co.addEventListener('click', function () {
        if (co.disabled) return;
        window.location.href = '/checkout';
      });

      var addrConfirm = $('#cdrwAddrConfirm');
      if (addrConfirm) addrConfirm.addEventListener('change', function () { self.gate(); });

      /* gift card message (same as PDP) — saved as cart attribute */
      var msgField = $('#cdrwMsgField');
      if (msgField) {
        var msgHdr = $('#cdrwMsgToggle');
        var msgTa = $('#cdrwMsgTA');
        msgHdr.addEventListener('click', function () {
          msgField.classList.toggle('open');
          var t = msgField.querySelector('.pers-tog');
          if (t) t.textContent = msgField.classList.contains('open') ? '−' : '+';
        });
        var saveT;
        function msgCounter() {
          if (msgTa.value.length > 250) msgTa.value = msgTa.value.slice(0, 250);
          var cc = $('#cdrwMsgCC');
          if (cc) cc.textContent = (250 - msgTa.value.length) + ' characters remaining';
        }
        function msgSave() {
          clearTimeout(saveT);
          saveT = setTimeout(function () {
            fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ attributes: { 'Card Message': msgTa.value } })
            }).catch(function () {});
          }, 600);
        }
        if (msgTa) {
          msgTa.addEventListener('input', function () { msgCounter(); msgSave(); });
          msgTa.addEventListener('blur', function () { clearTimeout(saveT); msgSave(); });
        }
        $$('.pers-tpl', msgField).forEach(function (b) {
          b.addEventListener('click', function (e) {
            e.stopPropagation();
            if (!msgField.classList.contains('open')) msgHdr.click();
            if (msgTa) { msgTa.value = b.getAttribute('data-tpl') || ''; msgCounter(); msgSave(); msgTa.focus(); }
          });
        });
      }

      this.refresh();
    },
    open: function () {
      if (!this.el) { window.location.href = '/cart'; return; }
      this.refresh();
      this.el.classList.add('open');
      document.body.style.overflow = 'hidden';
    },
    close: function () {
      if (!this.el) return;
      this.el.classList.remove('open');
      document.body.style.overflow = '';
    },
    refresh: function () {
      var self = this;
      return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        self.cart = cart;
        setCartCount(cart.item_count);
        self.render();
      }).catch(function () {});
    },
    /* Current date/time in the STORE's timezone (not the visitor's browser),
       so "today", the min date and the same-day cutoff are correct for an
       Australian florist even when the shopper is in another country. */
    storeNow: function () {
      var parts;
      try {
        parts = new Intl.DateTimeFormat('en-CA', {
          timeZone: this.cfg.tz, year: 'numeric', month: '2-digit', day: '2-digit',
          hour: '2-digit', minute: '2-digit', hour12: false
        }).formatToParts(new Date());
      } catch (e) { parts = null; }
      if (!parts) { var n = new Date(); return { date: n.toISOString().slice(0, 10), hour: n.getHours() }; }
      var m = {};
      parts.forEach(function (p) { m[p.type] = p.value; });
      var hour = parseInt(m.hour, 10); if (hour === 24) hour = 0;
      return { date: m.year + '-' + m.month + '-' + m.day, hour: hour };
    },
    onDate: function () {
      var date = $('#cdrwDate');
      var err = $('#cdrwErr');
      if (!date || !date.value) { this.gate(); return; }
      var d = new Date(date.value + 'T12:00:00');
      var now = this.storeNow();
      var msg = '';
      if (d.getDay() === 0) msg = 'Sorry, we don’t deliver on Sundays — please pick another day.';
      var isToday = date.value === now.date;
      if (!msg && isToday && now.hour >= this.cfg.cutoff) msg = 'Same-day cutoff (3PM) has passed — please choose tomorrow onwards.';
      if (err) { err.textContent = msg; err.classList.toggle('show', !!msg); }
      date.classList.toggle('sel', !msg && !!date.value);
      if (msg) { date.value = ''; this.gate(); return; }
      this.saveSchedule();
    },
    saveSchedule: function () {
      var date = $('#cdrwDate');
      this.gate();
      if (!date || !date.value) return;
      var d = new Date(date.value + 'T12:00:00');
      var nice = d.toLocaleDateString('en-AU', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { 'Delivery Date': nice } })
      }).catch(function () {});
    },
    gate: function () {
      var date = $('#cdrwDate');
      var co = $('#cdrwCheckout');
      var info = $('#cdrwInfo');
      var addrConfirm = $('#cdrwAddrConfirm');
      var scheduled = !!(date && date.value);
      var confirmed = !addrConfirm || addrConfirm.checked;
      var ready = scheduled && confirmed;
      if (co) co.disabled = !ready;
      if (info) {
        info.classList.toggle('ok', ready);
        var span = info.querySelector('span');
        if (span) span.textContent = ready
          ? 'Perfect! Your delivery date is set — you’re ready to checkout.'
          : (!scheduled
              ? 'Please select your delivery date above to enable checkout.'
              : 'Please tick the box to confirm your delivery address before checkout.');
      }
    },
    render: function () {
      var cart = this.cart;
      if (!cart) return;
      var items = $('#cdrwItems');
      var count = $('#cdrwCount');
      if (count) count.textContent = cart.item_count;

      /* free shipping bar */
      var fill = $('#cdrwShipFill'), shipT = $('#cdrwShipText');
      if (fill && shipT) {
        var pct = Math.min(100, Math.round(cart.total_price / this.cfg.freeShip * 100));
        fill.style.width = pct + '%';
        shipT.innerHTML = cart.total_price >= this.cfg.freeShip
          ? '🎉 You’ve unlocked <b>FREE delivery</b>!'
          : 'Add <b>' + formatMoney(this.cfg.freeShip - cart.total_price) + '</b> more for free delivery';
      }

      if (items) {
        if (!cart.items.length) {
          items.innerHTML = '<div class="cdrw-empty"><div class="em">🌸</div><p>Your cart is empty — beautiful blooms await.</p><a class="btn-rose" href="/collections/all">Shop All Flowers</a></div>';
        } else {
          var html = '';
          cart.items.forEach(function (it, i) {
            var props = '';
            if (it.properties) {
              Object.keys(it.properties).forEach(function (k) {
                if (k.charAt(0) !== '_' && it.properties[k]) props += escapeHtml(k) + ': ' + escapeHtml(String(it.properties[k]).slice(0, 40)) + '<br>';
              });
            }
            html += '<div class="cdrw-item" data-line="' + (i + 1) + '">' +
              '<a class="cdrw-img" href="' + it.url + '">' + (it.image ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/, '_180x$1$2') + '" alt="' + escapeHtml(it.product_title) + '" loading="lazy">' : '💐') + '</a>' +
              '<div class="cdrw-info">' +
                '<div class="cdrw-nm">' + escapeHtml(it.product_title) + '</div>' +
                '<div class="cdrw-mt">' + (it.variant_title ? escapeHtml(it.variant_title) + '<br>' : '') + props + '</div>' +
                '<div class="cdrw-row">' +
                  '<div class="cdrw-qty"><button class="cdrw-qb" data-d="-1" aria-label="Decrease">−</button><span class="cdrw-qn">' + it.quantity + '</span><button class="cdrw-qb" data-d="1" aria-label="Increase">+</button></div>' +
                  '<span class="cdrw-pr">' + formatMoney(it.final_line_price) + '</span>' +
                '</div>' +
                '<button class="cdrw-rm">Remove</button>' +
              '</div></div>';
          });
          items.innerHTML = html;
          var self = this;
          $$('.cdrw-qb', items).forEach(function (b) {
            b.addEventListener('click', function () {
              var row = b.closest('.cdrw-item');
              var line = parseInt(row.getAttribute('data-line'), 10);
              var qn = parseInt(row.querySelector('.cdrw-qn').textContent, 10);
              self.change(line, Math.max(0, qn + parseInt(b.getAttribute('data-d'), 10)), row);
            });
          });
          $$('.cdrw-rm', items).forEach(function (b) {
            b.addEventListener('click', function () {
              var row = b.closest('.cdrw-item');
              self.change(parseInt(row.getAttribute('data-line'), 10), 0, row);
            });
          });
        }
      }

      var sub = $('#cdrwSubtotal');
      if (sub) sub.textContent = formatMoney(cart.total_price);

      /* restore saved schedule */
      var date = $('#cdrwDate');
      if (date && !date.value && cart.attributes && cart.attributes['Delivery Date']) {
        var parsed = new Date(cart.attributes['Delivery Date']);
        if (!isNaN(parsed)) {
          /* use local Y-M-D parts, not toISOString() (UTC) which can shift a day back */
          var pad = function (x) { return (x < 10 ? '0' : '') + x; };
          date.value = parsed.getFullYear() + '-' + pad(parsed.getMonth() + 1) + '-' + pad(parsed.getDate());
        }
        date.classList.add('sel');
      }
      if (cart.attributes && cart.attributes['Delivery Time']) {
        $$('.cdrw-slot', this.el).forEach(function (s) {
          s.classList.toggle('on', s.getAttribute('data-slot') === cart.attributes['Delivery Time']);
        });
      }
      /* restore saved card message */
      var msgTa = $('#cdrwMsgTA');
      if (msgTa && !msgTa.value && cart.attributes && cart.attributes['Card Message']) {
        msgTa.value = cart.attributes['Card Message'];
        var cc = $('#cdrwMsgCC');
        if (cc) cc.textContent = (250 - msgTa.value.length) + ' characters remaining';
        var mf = $('#cdrwMsgField');
        if (mf && !mf.classList.contains('open')) {
          mf.classList.add('open');
          var t = mf.querySelector('.pers-tog');
          if (t) t.textContent = '−';
        }
      }
      this.gate();
    },
    change: function (line, qty, row) {
      var self = this;
      if (row) row.classList.add('busy');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      }).then(function (r) { return r.json(); }).then(function (cart) {
        self.cart = cart;
        setCartCount(cart.item_count);
        self.render();
        if (document.getElementById('pbCart')) window.location.reload();
      }).catch(function () { if (row) row.classList.remove('busy'); });
    }
  };

  /* ── AJAX add to cart ── */
  function addToCart(items, onDone, onErr) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'Could not add to cart'); });
      return r.json();
    }).then(function () {
      if (onDone) onDone();
    }).catch(function (e) {
      toast(e.message || 'Could not add to cart');
      if (onErr) onErr(e);
    });
  }

  function initQuickAdd() {
    document.addEventListener('click', function (ev) {
      var btn = ev.target.closest('[data-pb-quick-add]');
      if (!btn) return;
      ev.preventDefault(); ev.stopPropagation();
      var id = btn.getAttribute('data-pb-quick-add');
      if (!id) return;
      var orig = btn.innerHTML;
      btn.innerHTML = '…';
      addToCart([{ id: parseInt(id, 10), quantity: 1 }], function () {
        btn.innerHTML = '✓';
        setTimeout(function () { btn.innerHTML = orig; }, 1500);
        Drawer.open();
      }, function () { btn.innerHTML = orig; });
    });

    /* wishlist hearts */
    var KEY = 'pb_wishlist';
    function getWl() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
    function setWishCount() {
      $$('[data-pb-wish-count]').forEach(function (el) {
        var n = getWl().length;
        el.textContent = n;
        el.setAttribute('data-count', n);
      });
    }
    setWishCount();
    $$('[data-pb-wish]').forEach(function (b) {
      if (getWl().indexOf(b.getAttribute('data-pb-wish')) !== -1) b.classList.add('active');
    });
    document.addEventListener('click', function (ev) {
      var b = ev.target.closest('[data-pb-wish]');
      if (!b) return;
      ev.preventDefault(); ev.stopPropagation();
      var h = b.getAttribute('data-pb-wish');
      var wl = getWl();
      var i = wl.indexOf(h);
      if (i === -1) { wl.push(h); b.classList.add('active'); toast('Added to wishlist ♡', true); }
      else { wl.splice(i, 1); b.classList.remove('active'); }
      try { localStorage.setItem(KEY, JSON.stringify(wl)); } catch (e) {}
      setWishCount();
    });
  }

  /* ══════════════════════════════════════════════
     WISHLIST + RECENTLY VIEWED PAGES (localStorage)
  ══════════════════════════════════════════════ */
  function renderProductGrid(el, handles, storageKey) {
    var grid = el.querySelector('[data-pb-lsgrid]');
    var empty = el.querySelector('[data-pb-lsempty]');
    var countEl = el.querySelector('[data-pb-lscount]');
    if (!grid) return;
    if (!handles.length) {
      grid.style.display = 'none';
      if (empty) empty.style.display = '';
      if (countEl) countEl.textContent = '0 items';
      return;
    }
    if (countEl) countEl.textContent = handles.length + ' item' + (handles.length === 1 ? '' : 's');
    Promise.all(handles.map(function (h) {
      return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (prods) {
      var html = '';
      prods.forEach(function (p, i) {
        if (!p) return;
        var img = p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/, '_600x$1$2') : '';
        var sold = !p.available;
        var v = p.variants && p.variants[0];
        html += '<div class="pcard v' + (sold ? ' sold' : '') + '">' +
          '<a href="' + p.url + '" class="pc-img">' +
            (img ? '<div class="pc-img-bg"><img src="' + img + '" alt="' + escapeHtml(p.title) + '" loading="lazy"></div>' : '<div class="pc-img-bg p' + ((i % 8) + 1) + '">🌸</div>') +
            (sold ? '<span class="pc-badge b-out">Sold Out</span>' : '') +
            '<button class="pc-wish active" data-pb-wish="' + p.handle + '" aria-label="Toggle wishlist" type="button"><svg viewBox="0 0 24 24"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg></button>' +
          '</a>' +
          '<div class="pc-body">' +
            (p.type ? '<div class="pc-cat">' + escapeHtml(p.type) + '</div>' : '') +
            '<a href="' + p.url + '"><div class="pc-name">' + escapeHtml(p.title) + '</div></a>' +
            '<div class="pc-row"><span class="pc-price">' + formatMoney(p.price) + '</span>' +
            (sold || !v ? '' : (p.variants.length === 1
              ? '<button class="pc-add" data-pb-quick-add="' + v.id + '" aria-label="Add to cart" type="button"><svg viewBox="0 0 24 24"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg></button>'
              : '<a class="pc-add" href="' + p.url + '" aria-label="View product"><svg viewBox="0 0 24 24"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg></a>')) +
            '</div></div></div>';
      });
      if (html) {
        grid.innerHTML = html;
        if (empty) empty.style.display = 'none';
      } else {
        grid.style.display = 'none';
        if (empty) empty.style.display = '';
      }
      /* removing a heart on the wishlist page removes the card */
      if (storageKey === 'pb_wishlist') {
        $$('[data-pb-wish]', grid).forEach(function (b) {
          b.addEventListener('click', function () {
            setTimeout(function () {
              var card = b.closest('.pcard');
              if (card && !b.classList.contains('active')) card.remove();
              if (!grid.querySelector('.pcard')) { grid.style.display = 'none'; if (empty) empty.style.display = ''; }
            }, 50);
          });
        });
      }
    });
  }

  function initWishRecentPages() {
    var wl = $('#pbWishlistPage');
    if (wl) {
      var handles = [];
      try { handles = JSON.parse(localStorage.getItem('pb_wishlist')) || []; } catch (e) {}
      renderProductGrid(wl, handles.slice().reverse(), 'pb_wishlist');
    }
    var rv = $('#pbRecentPage');
    if (rv) {
      var rh = [];
      try { rh = JSON.parse(localStorage.getItem('pb_recent')) || []; } catch (e) {}
      var cur = (window.PB && window.PB.product && window.PB.product.handle) || null;
      renderProductGrid(rv, rh.filter(function (h) { return h !== cur; }), 'pb_recent');
    }
    /* track recently viewed on product pages */
    if (window.PB && window.PB.product && window.PB.product.handle) {
      try {
        var rec = JSON.parse(localStorage.getItem('pb_recent')) || [];
        rec = rec.filter(function (h) { return h !== window.PB.product.handle; });
        rec.unshift(window.PB.product.handle);
        localStorage.setItem('pb_recent', JSON.stringify(rec.slice(0, 12)));
      } catch (e) {}
    }
  }

  /* ══════════════════════════════════════════════
     PREDICTIVE SEARCH OVERLAY
  ══════════════════════════════════════════════ */
  function initPredictiveSearch() {
    var psr = $('#pbPsr');
    if (!psr) return;
    var input = $('#pbPsrInput');
    var results = $('#pbPsrResults');
    var defaultHtml = results ? results.innerHTML : '';

    function open() {
      psr.classList.add('open');
      document.body.style.overflow = 'hidden';
      setTimeout(function () { input && input.focus(); }, 120);
    }
    function close() {
      psr.classList.remove('open');
      document.body.style.overflow = '';
    }
    $$('[data-pb-search-open]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); close(); var d = $('#pbMobDrawer'); if (d) d.classList.remove('open'); open(); });
    });

    /* inline header search box → seamlessly continues typing in the overlay */
    var hs = $('#pbHSearch');
    if (hs && input) {
      function hsOpen() {
        open();
        if (hs.value) {
          input.value = hs.value;
          input.dispatchEvent(new Event('input'));
        }
        hs.value = '';
      }
      hs.addEventListener('focus', hsOpen);
      hs.addEventListener('input', hsOpen);
      hs.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' && hs.value.trim()) {
          window.location.href = '/search?q=' + encodeURIComponent(hs.value.trim()) + '&type=product';
        }
      });
    }
    $$('.psr-bg, .psr-close', psr).forEach(function (x) { x.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    var t;
    if (input) input.addEventListener('input', function () {
      clearTimeout(t);
      var q = input.value.trim();
      if (q.length < 2) { if (results) results.innerHTML = defaultHtml; return; }
      t = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,query,collection&resources[limit]=6&resources[options][unavailable_products]=last')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var rs = (data.resources && data.resources.results) || {};
            var prods = rs.products || [];
            var queries = rs.queries || [];
            var cols = rs.collections || [];
            var html = '<div class="psr-cols">';
            html += '<div><div class="psr-sec-h">Suggestions</div><div class="psr-sug">';
            if (queries.length || cols.length) {
              queries.forEach(function (s) {
                html += '<a href="/search?q=' + encodeURIComponent(s.text) + '&type=product"><svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>' + s.styled_text.replace(/<mark/g, '<b').replace(/<\/mark>/g, '</b>') + '</a>';
              });
              cols.forEach(function (c) {
                html += '<a href="' + c.url + '"><svg viewBox="0 0 24 24"><path d="M3 7h18M3 12h18M3 17h18"/></svg>' + escapeHtml(c.title) + '</a>';
              });
            } else {
              html += '<span style="font-size:12px;color:var(--ink-muted)">No suggestions</span>';
            }
            html += '</div></div>';
            html += '<div><div class="psr-sec-h">Products</div>';
            if (prods.length) {
              html += '<div class="psr-prods">';
              prods.forEach(function (p) {
                html += '<a class="psr-p" href="' + p.url + '">' +
                  '<span class="psr-p-img">' + (p.featured_image && p.featured_image.url ? '<img src="' + p.featured_image.url + '&width=120" alt="' + escapeHtml(p.title) + '">' : '🌸') + '</span>' +
                  '<span><span class="psr-p-t">' + escapeHtml(p.title) + '</span><span class="psr-p-pr">' + (p.price ? 'From $' + p.price : '') + '</span></span></a>';
              });
              html += '</div>';
              html += '<a class="psr-all btn-outline" href="/search?q=' + encodeURIComponent(q) + '&type=product">View all results for “' + escapeHtml(q) + '” →</a>';
            } else {
              html += '<div class="psr-empty">No flowers found for “' + escapeHtml(q) + '” — try “roses” or “birthday”</div>';
            }
            html += '</div></div>';
            if (results) results.innerHTML = html;
          }).catch(function () {});
      }, 220);
    });
    if (input) input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && input.value.trim()) {
        window.location.href = '/search?q=' + encodeURIComponent(input.value.trim()) + '&type=product';
      }
    });
  }

  /* ── Collection page ── */
  function initCollection() {
    var grid = $('#pgGrid');
    if (!grid) return;

    $$('[data-pb-view]').forEach(function (b) {
      b.addEventListener('click', function () {
        grid.className = 'pg-grid ' + (b.getAttribute('data-pb-view') || '');
        $$('[data-pb-view]').forEach(function (x) { x.classList.remove('on'); });
        b.classList.add('on');
      });
    });

    var sort = $('#pbSort');
    if (sort) sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });

    $$('.sb-title').forEach(function (t) {
      t.addEventListener('click', function () { t.classList.toggle('open'); });
    });

    $$('form.pb-facets').forEach(function (form) {
      form.addEventListener('change', function (ev) {
        if (ev.target.matches('input[type=checkbox]')) form.submit();
      });
    });

    var fd = $('#pbFiltDrawer');
    var ft = $('#pbFiltToggle');
    if (ft && fd) {
      ft.addEventListener('click', function () {
        if (window.innerWidth > 1100) {
          var sb = $('#pbSidebar'), layout = $('#pbColLayout');
          if (sb && layout) {
            var hidden = sb.style.display === 'none';
            sb.style.display = hidden ? '' : 'none';
            layout.classList.toggle('no-sidebar', !hidden);
            ft.classList.toggle('on', hidden);
          }
        } else {
          fd.classList.add('open'); document.body.style.overflow = 'hidden';
        }
      });
      $$('.filt-drawer-bg, [data-pb-filt-close]', fd).forEach(function (el) {
        el.addEventListener('click', function () { fd.classList.remove('open'); document.body.style.overflow = ''; });
      });
      $$('.sb-title', fd).forEach(function (t) {
        t.addEventListener('click', function () { t.classList.toggle('open'); });
      });
    }

    var lm = $('#pbLoadMore');
    if (lm) lm.addEventListener('click', function () {
      var next = lm.getAttribute('data-next-url');
      if (!next) return;
      lm.textContent = 'Loading…';
      fetch(next).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('#pgGrid');
        var newLm = doc.querySelector('#pbLoadMore');
        if (newGrid) {
          Array.prototype.slice.call(newGrid.children).forEach(function (c) {
            c.classList.add('v');
            grid.appendChild(c);
          });
        }
        var info = $('#pbLmInfo');
        if (info) info.innerHTML = 'Showing <strong>' + grid.children.length + '</strong> of <strong>' + (info.getAttribute('data-total') || grid.children.length) + '</strong>';
        if (newLm && newLm.getAttribute('data-next-url')) {
          lm.setAttribute('data-next-url', newLm.getAttribute('data-next-url'));
          lm.innerHTML = 'Load More Arrangements →';
        } else {
          lm.style.display = 'none';
        }
      }).catch(function () { lm.innerHTML = 'Load More Arrangements →'; });
    });
  }

  /* ══════════════════════════════════════════════
     PRODUCT PAGE
  ══════════════════════════════════════════════ */
  function initProduct() {
    var pz = $('#pbProduct');
    if (!pz) return;
    var data = window.PB && window.PB.product;
    if (!data) return;

    var state = { variantId: data.selected_variant_id, price: data.selected_price || 0, qty: 1, date: null, msg: '' };

    function updateAfterpay(price) {
      var ap = $('#afterpayAmt');
      if (ap) ap.textContent = formatMoney(Math.ceil(price / 4));
    }
    updateAfterpay(state.price);
    var apInfo = $('#afterpayInfo');
    if (apInfo) apInfo.addEventListener('click', function () {
      var tip = $('#afterpayTip');
      if (tip) tip.classList.toggle('show');
    });

    /* ── Frequently bought together / add-ons ── */
    function fbtTotal() {
      var total = state.price;
      var parts = [];
      $$('.fbt-card.on').forEach(function (c) {
        total += parseInt(c.getAttribute('data-price'), 10) || 0;
        parts.push(escapeHtml(c.getAttribute('data-title')) + ' ' + formatMoney(parseInt(c.getAttribute('data-price'), 10) || 0));
      });
      var v = $('#fbtTotalVal');
      if (v) v.textContent = formatMoney(total);
      var brk = $('#fbtBreak');
      if (brk) brk.innerHTML = parts.length
        ? 'Bouquet ' + formatMoney(state.price) + ' + ' + parts.join(' + ')
        : 'Just the bouquet — add something special above';
      var acPrice = $('#acPrice');
      if (acPrice) acPrice.textContent = formatMoney(total);
      var mob = $('#pdpMobPrice');
      if (mob && parts.length) mob.textContent = formatMoney(total) + ' incl. add-ons';
    }
    $$('.fbt-card').forEach(function (c) {
      c.addEventListener('click', function () {
        c.classList.toggle('on');
        var chk = c.querySelector('.fbt-check');
        if (chk) chk.textContent = c.classList.contains('on') ? '✓' : '';
        fbtTotal();
      });
    });

    /* gallery */
    var main = $('#galMain');
    $$('.gal-th').forEach(function (th) {
      th.addEventListener('click', function () {
        $$('.gal-th').forEach(function (x) { x.classList.remove('active'); });
        th.classList.add('active');
        if (main) {
          var src = th.getAttribute('data-full');
          var img = main.querySelector('img');
          if (src && img) {
            /* srcset wins over src in the browser, so update both (and sizes) or the image won't change */
            img.srcset = src;
            img.removeAttribute('sizes');
            img.src = src;
          }
        }
      });
    });

    /* ── option-based variant pills (Size / Style / Delivery …) ── */
    var sel = (data.selected_options || []).slice();
    function applyVariant(v) {
      state.variantId = v.id;
      state.price = v.price;
      var pm = $('#pzPrice'); if (pm) pm.textContent = formatMoney(v.price);
      var cmp = v.compare_at_price || 0;
      var was = $('#pzWas'), save = $('#pzSave');
      if (was && save) {
        if (cmp > v.price) {
          var pct = Math.round((cmp - v.price) / cmp * 100);
          was.style.display = ''; was.textContent = formatMoney(cmp);
          save.style.display = ''; save.textContent = pct + '% OFF · Save ' + formatMoney(cmp - v.price);
        } else { was.style.display = 'none'; save.style.display = 'none'; }
      }
      var note = $('#pzNote'); if (note) note.textContent = v.title;
      var mob = $('#pdpMobPrice'); if (mob) mob.textContent = formatMoney(v.price) + ' · ' + v.title;
      var btn = $('#acBtn');
      if (btn) {
        btn.disabled = !v.available;
        var lbl = $('#acLabel'); if (lbl) lbl.textContent = v.available ? 'Add to Cart —' : 'Sold Out';
      }
      updateAfterpay(v.price);
      fbtTotal();
    }
    function findVariant() {
      return (data.variants || []).find(function (v) {
        return (sel[0] == null || v.option1 === sel[0]) &&
               (sel[1] == null || v.option2 === sel[1]) &&
               (sel[2] == null || v.option3 === sel[2]);
      });
    }
    $$('.opt-pill').forEach(function (p) {
      p.addEventListener('click', function () {
        var gi = parseInt(p.getAttribute('data-opt'), 10) - 1;
        sel[gi] = p.getAttribute('data-value');
        $$('.opt-pill[data-opt="' + (gi + 1) + '"]').forEach(function (x) { x.classList.remove('on'); });
        p.classList.add('on');
        var v = findVariant();
        if (v) applyVariant(v);
        else {
          var btn = $('#acBtn');
          if (btn) { btn.disabled = true; var lbl = $('#acLabel'); if (lbl) lbl.textContent = 'Unavailable'; }
        }
      });
    });

    /* delivery date pills */
    $$('.dpill[data-date]').forEach(function (p) {
      p.addEventListener('click', function () {
        if (p.classList.contains('dis')) return;
        $$('.dpill').forEach(function (x) { x.classList.remove('on'); });
        p.classList.add('on');
        state.date = p.getAttribute('data-date');
      });
      if (p.classList.contains('on')) state.date = p.getAttribute('data-date');
    });

    /* card message: toggle, templates, counter */
    var pers = $('#persField');
    if (pers) {
      var hdr = pers.querySelector('.pers-hdr');
      hdr.addEventListener('click', function () {
        pers.classList.toggle('open');
        var t = pers.querySelector('.pers-tog');
        if (t) t.textContent = pers.classList.contains('open') ? '−' : '+';
      });
      var ta = pers.querySelector('textarea');
      var maxLen = ta ? (parseInt(ta.getAttribute('maxlength'), 10) || 250) : 250;
      function counter() {
        if (!ta) return;
        if (ta.value.length > maxLen) ta.value = ta.value.slice(0, maxLen);
        state.msg = ta.value;
        var cc = $('#persCC'); if (cc) cc.textContent = (maxLen - ta.value.length) + ' characters remaining';
      }
      if (ta) ta.addEventListener('input', counter);
      $$('.pers-tpl', pers).forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.stopPropagation();
          if (!pers.classList.contains('open')) hdr.click();
          if (ta) { ta.value = b.getAttribute('data-tpl') || ''; counter(); ta.focus(); }
        });
      });
    }

    /* collapsibles */
    $$('.coll-t').forEach(function (t) {
      t.addEventListener('click', function () { t.parentElement.classList.toggle('open'); });
    });

    /* tabs */
    $$('.ptab-btn').forEach(function (b) {
      b.addEventListener('click', function () {
        $$('.ptab-btn').forEach(function (x) { x.classList.remove('active'); });
        $$('.ptab-panel').forEach(function (x) { x.classList.remove('active'); });
        b.classList.add('active');
        var panel = $('#tab-' + b.getAttribute('data-tab'));
        if (panel) panel.classList.add('active');
      });
    });
    $$('[data-open-tab]').forEach(function (l) {
      l.addEventListener('click', function () {
        var b = $('.ptab-btn[data-tab="' + l.getAttribute('data-open-tab') + '"]');
        if (b) { b.click(); b.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      });
    });

    /* build cart payload: main product + selected add-ons */
    function buildItems() {
      var props = {};
      if (state.date) props['Delivery date'] = state.date;
      if (state.msg) props['Gift message'] = state.msg;
      var items = [{ id: parseInt(state.variantId, 10), quantity: state.qty, properties: props }];
      $$('.fbt-card.on').forEach(function (c) {
        var vid = parseInt(c.getAttribute('data-variant-id'), 10);
        if (vid) items.push({ id: vid, quantity: 1, properties: { '_addon': 'yes' } });
      });
      return items;
    }

    function doAdd(btn) {
      if (!state.variantId) return;
      var orig = btn.innerHTML;
      btn.disabled = true;
      addToCart(buildItems(), function () {
        btn.innerHTML = '✓ Added to Cart!';
        setTimeout(function () { btn.innerHTML = orig; btn.disabled = false; }, 2000);
        Drawer.open();
      }, function () { btn.innerHTML = orig; btn.disabled = false; });
    }
    var acBtn = $('#acBtn');
    if (acBtn) acBtn.addEventListener('click', function () { doAdd(acBtn); });
    var mobBtn = $('#pdpMobBtn');
    if (mobBtn) mobBtn.addEventListener('click', function () { doAdd(acBtn || mobBtn); });

    var bn = $('#bnBtn');
    if (bn) bn.addEventListener('click', function () {
      bn.textContent = 'One moment…';
      addToCart(buildItems(), function () {
        window.location.href = '/checkout';
      }, function () { bn.textContent = 'Buy Now · Express Checkout'; });
    });
  }

  /* ── Cart page ── */
  function initCart() {
    var cartEl = $('#pbCart');
    if (!cartEl) return;

    function updateLine(line, qty, row) {
      if (row) row.classList.add('busy');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      }).then(function (r) { return r.json(); }).then(function () {
        window.location.reload();
      }).catch(function () {
        if (row) row.classList.remove('busy');
        toast('Could not update cart');
      });
    }

    $$('[data-pb-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var row = b.closest('.ci-row');
        var line = parseInt(row.getAttribute('data-line'), 10);
        var cur = parseInt(row.getAttribute('data-qty'), 10);
        updateLine(line, Math.max(0, cur + parseInt(b.getAttribute('data-pb-qty'), 10)), row);
      });
    });
    $$('[data-pb-remove]').forEach(function (b) {
      b.addEventListener('click', function () {
        var row = b.closest('.ci-row');
        updateLine(parseInt(row.getAttribute('data-line'), 10), 0, row);
      });
    });

    $$('[data-pb-upsell]').forEach(function (p) {
      p.addEventListener('click', function () {
        var id = parseInt(p.getAttribute('data-pb-upsell'), 10);
        p.style.opacity = '.5';
        addToCart([{ id: id, quantity: 1 }], function () { window.location.reload(); }, function () { p.style.opacity = ''; });
      });
    });

    var pBtn = $('#pbPromoBtn'), pInp = $('#pbPromoInp');
    if (pBtn && pInp) pBtn.addEventListener('click', function () {
      var code = pInp.value.trim();
      if (!code) return;
      document.cookie = 'discount_code=' + encodeURIComponent(code) + ';path=/';
      fetch('/discount/' + encodeURIComponent(code)).finally(function () {
        pBtn.textContent = '✓ Applied at checkout';
        setTimeout(function () { pBtn.textContent = 'Apply'; }, 2600);
      });
      toast('Code will apply at checkout', true);
    });
  }

  /* ── Mobile accordions: footer + SEO section ── */
  function initAccordions() {
    $$('[data-pb-acc]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (window.innerWidth > 768) return;
        btn.closest('[data-pb-acc-wrap]').classList.toggle('open');
      });
    });
  }

  /* ── Newsletter inline success ── */
  function initNewsletter() {
    if (window.location.search.indexOf('customer_posted=true') !== -1) {
      var nl = $('.nl-inner');
      if (nl) {
        var ok = document.createElement('div');
        ok.className = 'nl-success';
        ok.textContent = '✓ Subscribed! Welcome to the family.';
        nl.appendChild(ok);
      }
    }
  }

  /* ══════════════════════════════════════════════
     ZIPCODE DELIVERY CHECKER
  ══════════════════════════════════════════════ */
  function initZipCheck() {
    var pill = $('#pbZipPill');
    var pop = $('#pbZipPop');
    if (!pill || !pop) return;
    var input = $('#pbZipInput');
    var result = $('#pbZipResult');
    var label = $('#pbZipLabel');
    var edit = $('#pbZipEdit');

    var zones = [];
    (pop.getAttribute('data-zones') || '').split(',').forEach(function (z) {
      var p = z.trim().split('-');
      if (p.length === 2) zones.push([parseInt(p[0], 10), parseInt(p[1], 10)]);
      else if (p[0]) zones.push([parseInt(p[0], 10), parseInt(p[0], 10)]);
    });
    function deliverable(code) {
      var n = parseInt(code, 10);
      return zones.some(function (z) { return n >= z[0] && n <= z[1]; });
    }
    function show(code, suburb) {
      var ok = deliverable(code);
      if (result) {
        result.className = 'zip-result show ' + (ok ? 'ok' : 'no');
        result.innerHTML = ok
          ? '🎉 Great news! We deliver to <b>' + code + '</b> — order before 3PM for same-day delivery.'
          : 'Sorry, we don’t deliver to <b>' + code + '</b> yet. Call <a href="tel:+61393742929" style="text-decoration:underline">+61 3 9374 2929</a> — we may still be able to help.';
      }
      pill.classList.remove('ok', 'no');
      pill.classList.add(ok ? 'ok' : 'no');
      if (label) label.textContent = suburb ? (suburb + ', ' + code) : code;
      if (edit) edit.style.display = 'inline-block';
      try {
        localStorage.setItem('pb_zip', code);
        if (suburb) localStorage.setItem('pb_suburb', suburb);
      } catch (e) {}
    }

    function togglePop() {
      pop.classList.toggle('open');
      if (pop.classList.contains('open') && input) setTimeout(function () { input.focus(); }, 80);
    }
    pill.addEventListener('click', function (e) { e.stopPropagation(); togglePop(); });
    if (edit) edit.addEventListener('click', function (e) { e.stopPropagation(); togglePop(); });
    document.addEventListener('click', function (e) {
      if (!pop.contains(e.target) && e.target !== pill && !pill.contains(e.target)) pop.classList.remove('open');
    });

    var check = $('#pbZipCheck');
    function doCheck() {
      var v = (input && input.value || '').replace(/\D/g, '');
      if (v.length !== 4) {
        if (result) { result.className = 'zip-result show no'; result.textContent = 'Please enter a valid 4-digit Australian postcode.'; }
        return;
      }
      show(v);
    }
    if (check) check.addEventListener('click', doCheck);
    if (input) input.addEventListener('keydown', function (e) { if (e.key === 'Enter') doCheck(); });

    /* auto-detect via browser geolocation + free reverse geocode */
    var auto = $('#pbZipAuto');
    if (auto) auto.addEventListener('click', function () {
      if (!navigator.geolocation) return;
      auto.textContent = 'Detecting…';
      navigator.geolocation.getCurrentPosition(function (pos) {
        fetch('https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=' + pos.coords.latitude + '&longitude=' + pos.coords.longitude + '&localityLanguage=en')
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var code = d.postcode || '';
            var suburb = d.locality || d.city || d.principalSubdivision || '';
            auto.textContent = 'Use my current location';
            if (code && /^\d{4}$/.test(code)) {
              if (input) input.value = code;
              show(code, suburb);
            } else if (result) {
              result.className = 'zip-result show no';
              result.textContent = 'Couldn’t detect your postcode — please type it above.';
            }
          }).catch(function () { auto.textContent = 'Use my current location'; });
      }, function () { auto.textContent = 'Use my current location'; });
    });

    /* restore saved */
    try {
      var saved = localStorage.getItem('pb_zip');
      var savedSuburb = localStorage.getItem('pb_suburb') || '';
      if (saved) { if (input) input.value = saved; show(saved, savedSuburb); if (result) result.classList.remove('show'); }
    } catch (e) {}
  }

  /* ── Copy code (welcome page) ── */
  function initCopy() {
    $$('[data-pb-copy]').forEach(function (b) {
      b.addEventListener('click', function () {
        var txt = b.getAttribute('data-pb-copy');
        function done() { var o = b.textContent; b.textContent = '✓ Copied'; setTimeout(function () { b.textContent = o; }, 2000); }
        if (navigator.clipboard) navigator.clipboard.writeText(txt).then(done).catch(done);
        else done();
      });
    });
  }

  /* Hide the Judge.me reviews section gracefully when the app isn't installed yet */
  function initJudgeMeFallback() {
    var sec = $('.pb-reviews');
    if (!sec) return;
    setTimeout(function () {
      var widget = sec.querySelector('.jdgm-review-widget');
      if (!window.jdgm && widget && !widget.children.length && !widget.textContent.trim()) {
        sec.classList.add('jdgm-missing');
      }
    }, 3500);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initJudgeMeFallback();
    initHeader();
    initCountdown();
    Drawer.init();
    initQuickAdd();
    initPredictiveSearch();
    initCollection();
    initProduct();
    initCart();
    initAccordions();
    initNewsletter();
    initCopy();
    initWishRecentPages();
    initZipCheck();
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { setCartCount(c.item_count); }).catch(function () {});
  });
})();
